import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <div className="page-content">
      <section className="hero">
        <div className="hero-content">
          <h2>Expert Legal Representation in Family Law & Personal Injury</h2>
          <p>Serving Kelowna, BC and the Okanagan Valley with dedication, integrity, and results-driven advocacy since 2008</p>
          <Link to="/contact" className="cta-button">Schedule a Free Consultation</Link>
        </div>
      </section>

      <section className="content-section">
        <h2 className="section-title">Our Practice Areas</h2>
        <div className="practice-areas">
          <div className="practice-card">
            <h3>Family Law</h3>
            <p>Compassionate guidance through divorce, custody, support, and property division matters. We understand that family law cases affect your most important relationships.</p>
            <Link to="/family-law" className="learn-more">Learn More →</Link>
          </div>
          <div className="practice-card">
            <h3>Personal Injury</h3>
            <p>Aggressive representation for accident victims. We fight to secure the compensation you deserve for your injuries, lost wages, and pain and suffering.</p>
            <Link to="/personal-injury" className="learn-more">Learn More →</Link>
          </div>
        </div>
      </section>

      <section className="content-section" style={{ background: 'white' }}>
        <h2 className="section-title">Why Choose Sol LLP?</h2>
        <div className="practice-areas">
          <div className="practice-card">
            <h3>Experienced Team</h3>
            <p>Over 40 years of combined legal experience serving the Kelowna community</p>
          </div>
          <div className="practice-card">
            <h3>Client-Focused</h3>
            <p>Personalized attention and clear communication throughout your case</p>
          </div>
          <div className="practice-card">
            <h3>Proven Results</h3>
            <p>Successful track record in negotiations, mediation, and courtroom litigation</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;

